import React from 'react';
import classnames from 'classnames';
import { cssBEM } from './constants';
import { useIntl } from 'react-intl';
import {useCardBuilderContext} from './CardBuilder';

/* eslint-disable react/prop-types */
const Card = ({
  card,
  disabled,
  isActive,
  onAddClicked,
  onEditClicked,
  onRemoveClicked,
  renderCardBodyFn,
}) => {
  const { builderKey, MessageComponent } = useCardBuilderContext();
  const intl = useIntl();
  const messagesLabel = intl.formatMessage({ id: card.labelMessageId });
  const stripTags = /(<([^>]+)>)/gi;
  const cardLabel = messagesLabel.replace(stripTags, '');
  const classes = classnames(`${cssBEM}__card`, {
    [`${cssBEM}__card--active`]: isActive,
    [`${cssBEM}__card--inactive`]: !isActive,
  });

  const addBtn = (
    <button
      type="button"
      className={`${cssBEM}__btn ${cssBEM}__btn--addCard`}
      onClick={() => onAddClicked(card)}
      role="button"
      aria-label={`Add ${cardLabel}`}
    >
      <MessageComponent id={`${builderKey}cardBuilder.addCard`} />
    </button>
  );

  const editBtn = (
    <button
      type="button"
      className={`${cssBEM}__btn ${cssBEM}__btn--editCard`}
      onClick={() => onEditClicked(card)}
      role="button"
      aria-label={`Edit ${cardLabel}`}
    >
      <MessageComponent id={`${builderKey}cardBuilder.editCard`} />
    </button>
  );

  const removeBtn = (
    <button
      type="button"
      className={`${cssBEM}__btn ${cssBEM}__btn--removeCard`}
      onClick={() => onRemoveClicked(card)}
      role="button"
      aria-label={`Remove ${cardLabel}`}
    >
      <MessageComponent id={`${builderKey}cardBuilder.removeCard`} />
    </button>
  );

  const renderCardBody = () => {
    let render = null;
    if (renderCardBodyFn) {
      const cardParams = {
        card,
        isActive,
        onAddClicked,
        onEditClicked,
        onRemoveClicked,
      };
      render = (
        <div className={`${cssBEM}__card-content-body`}>
          {renderCardBodyFn(cardParams)}
        </div>
      );
    }
    return render;
  };

  const onCardClick = () => isActive ? onEditClicked(card) : onAddClicked(card);

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onCardClick();
    }
  };

  return (
    <div className={classes} id={`cardBuilderCard-${card.id}`}>
      <div className={`${cssBEM}__card-actions`}>
        {!isActive && !disabled ? addBtn : null}
        {isActive && !disabled ? editBtn : null}
        {isActive ? removeBtn : null}
      </div>

      <section className={`${cssBEM}__card-content`} onClick={onCardClick} onKeyPress={handleKeyPress} tabIndex="0">
        <div className="card-title"><MessageComponent id={card.labelMessageId} /></div>
        {renderCardBody()}
      </section>
    </div>
  );
};

export default Card;
